import { useState } from 'react';

import type { SharePointDocument } from '@/api/types';

function groupDocumentsByDrive(documents: Array<SharePointDocument>) {
  const grouped = new Map<string, Array<SharePointDocument>>();
  for (const document of documents) {
    const list = grouped.get(document.drive) ?? [];
    list.push(document);
    grouped.set(document.drive, list);
  }
  return grouped;
}

export function useDocumentsStep({
  documents,
  selectedDocumentIds,
  toggleDocument,
  toggleDocuments,
}: {
  documents: Array<SharePointDocument> | undefined;
  selectedDocumentIds: Array<string>;
  toggleDocument: (id: string) => void;
  toggleDocuments: (ids: Array<string>) => void;
}) {
  const grouped = groupDocumentsByDrive(documents ?? []);
  const drives = [...grouped.keys()];

  const [driveOverride, setSelectedDrive] = useState<string | null>(null);
  const selectedDrive =
    driveOverride && grouped.has(driveOverride) ? driveOverride : (drives[0] ?? '');

  const allIds = (documents ?? []).map((document) => document.id);
  const selectedDriveIds = (grouped.get(selectedDrive) ?? []).map((document) => document.id);
  const selectedDocuments = (documents ?? []).filter((document) =>
    selectedDocumentIds.includes(document.id)
  );

  const allSelected = allIds.length > 0 && allIds.every((id) => selectedDocumentIds.includes(id));
  const driveAllSelected =
    selectedDriveIds.length > 0 &&
    selectedDriveIds.every((id) => selectedDocumentIds.includes(id));

  return {
    grouped,
    drives,
    selectedDrive,
    setSelectedDrive,
    allIds,
    allSelected,
    selectedDriveIds,
    driveAllSelected,
    selectedDocuments,
    toggleDocument,
    toggleDocuments,
  };
}
